import { Skeleton } from '@/components/ui/skeleton';
import { ConnectorRowSkeleton } from '@/components/tenants/home/connector-row-skeleton';

/* ------------------------------------------------------------------ */
/*  DashboardSkeleton                                                  */
/*                                                                     */
/*  Mirrors the shape of DashboardView (home.tsx): hero card, activity */
/*  chart card, and the connector grid — so the page settles into      */
/*  content without a layout shift from a centered spinner.            */
/* ------------------------------------------------------------------ */

function HeroSkeleton() {
  return (
    <div className="bg-card relative overflow-hidden rounded-xl border p-6">
      <div className="flex flex-col gap-5">
        {/* Freshness row */}
        <Skeleton className="h-4 w-28" />
        {/* Metrics row */}
        <div className="flex flex-wrap gap-4 border-t pt-4">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
    </div>
  );
}

function ActivityChartSkeleton() {
  return (
    <div className="bg-card flex flex-col gap-4 rounded-xl border p-4">
      {/* Header */}
      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-3 w-44" />
      </div>
      {/* Chart area — matches ResponsiveContainer height of 180 */}
      <Skeleton className="h-[180px] w-full" />
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6 px-5 py-10 sm:px-4 sm:py-8">
      <HeroSkeleton />
      <ActivityChartSkeleton />
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-6 w-32" />
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <ConnectorRowSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
